import type { ReactNode } from 'react';

interface Props {
  lead?: ReactNode;
  trail?: ReactNode;
  children: ReactNode;
  className?: string;
}

/** Linha de lista. Rótulo é `ReactNode` já construído — nunca HTML cru. */
export function Linha({ lead, trail, children, className }: Props) {
  return (
    <div className={className ? `kit-linha ${className}` : 'kit-linha'}>
      {lead != null && <span className="kit-linha__lead">{lead}</span>}
      <span className="kit-linha__corpo">{children}</span>
      {trail != null && <span className="kit-linha__trail">{trail}</span>}
    </div>
  );
}
